/**
 * Shared product-condition catalog.
 *
 * Matches the backend enum at /app/backend/models/common.py
 * (ProductCondition). Keep the order meaningful — the Sell wizard / edit
 * form renders these top-to-bottom, premium-first.
 */
export const PRODUCT_CONDITIONS: {
  value: string;
  label: string;
  hint: string;
}[] = [
  { value: "NEW", label: "New", hint: "Factory-sealed, never installed." },
  {
    value: "NEW_OPEN_BOX",
    label: "New — Open Box",
    hint: "Brand-new, packaging opened for inspection only.",
  },
  {
    value: "REFURBISHED",
    label: "Refurbished",
    hint: "Restored to full working order by a certified tech.",
  },
  {
    value: "USED_LIKE_NEW",
    label: "Used — Like New",
    hint: "Barely used. No visible wear.",
  },
  {
    value: "USED_GOOD",
    label: "Used — Good",
    hint: "Normal wear, fully functional.",
  },
  {
    value: "USED_ACCEPTABLE",
    label: "Used — Acceptable",
    hint: "Heavy wear; still works.",
  },
  {
    value: "FOR_PARTS",
    label: "For parts or not working",
    hint: "Sold as-is for harvest / repair.",
  },
  // Back-compat value so pre-Phase-10 listings still render.
  { value: "USED", label: "Used", hint: "Legacy tier — treated as Used - Good." },
];

export function conditionLabel(value: string | null | undefined): string {
  if (!value) return "Unspecified";
  return PRODUCT_CONDITIONS.find((c) => c.value === value)?.label ?? value;
}
